import { CiMail } from 'react-icons/ci';
import { IconButton, Badge } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getEmailCount } from 'app/store/actions/emailCount';

export const NavbarEmailButton = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [count, setCount] = useState<number>(0);

  const request = () => {
    getEmailCount().then((res: any) => {
      if (res.status === 201) {
        setData(res.data);
      }
    });
  };

  useEffect(() => {
    if (data.length > 0) {
      const sum = data.reduce((prev, current) => prev + current?.unreadCount, 0);
      setCount(sum);
    }
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => request(), 3600000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <IconButton
      onClick={() => navigate('/lawyer/mail')}
      sx={{ border: '2px solid transparent', background: 'white' }}
    >
      <Badge
        badgeContent={count}
        color="error"
        // variant="dot"
        invisible={count === 0}
      >
        <CiMail />
      </Badge>
    </IconButton>
  );
};
